import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DomSanitizer, SafeResourceUrl, SafeUrl } from '@angular/platform-browser';
import { AppConfigService } from 'src/app/services/app-config/app-config.service';

@Component({
  selector: 'app-help-dialog',
  templateUrl: './help-dialog.component.html',
  styleUrls: ['./help-dialog.component.scss']
})
export class HelpDialogComponent {

  public trustedUrl: SafeResourceUrl;
  public appName: string;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: string,
    private sanitizer: DomSanitizer,
    private appConfig: AppConfigService
  ) {
    this.trustedUrl = sanitizer.bypassSecurityTrustResourceUrl(data);
    this.appName = this.appConfig.appName;
  }
}
